import axios from 'axios';
import {
  GET_USER_PROFILE_DETAILS_API_URL,
  UPDATE_USER,
  get_request_config
} from '@/utils/system_constants/constant';

function normalize_profile(payload = {}) {
  const first_name = String(payload?.first_name || '').trim();
  const last_name = String(payload?.last_name || '').trim();
  const full_name = String(payload?.full_name || '').trim() || `${first_name} ${last_name}`.trim();

  return {
    id: Number(payload?.id || 0) || null,
    email: String(payload?.email || '').trim(),
    first_name,
    last_name,
    full_name,
    is_active: Boolean(payload?.is_active),
    phone_number: String(payload?.phone_number || '').trim(),
    date_joined: String(payload?.date_joined || '').trim()
  };
}

export async function fetch_user_profile_details(user_id) {
  const normalized_user_id = Number(user_id || 0);

  if (!normalized_user_id) {
    throw new Error('A valid user id is required to load the profile.');
  }

  const response = await axios.get(
    GET_USER_PROFILE_DETAILS_API_URL,
    get_request_config({ params: { user_id: normalized_user_id } })
  );

  const payload = response?.data;
  if (payload?.status && String(payload.status).toLowerCase() !== 'success') {
    throw new Error(String(payload?.message || 'Unable to load profile details.'));
  }

  return normalize_profile(payload?.data || {});
}

export async function update_user_profile_details({ user_id, first_name, last_name, phone_number }) {
  const normalized_user_id = Number(user_id || 0);

  if (!normalized_user_id) {
    throw new Error('A valid user id is required to update the profile.');
  }

  const payload = {
    user_id: normalized_user_id,
    first_name: String(first_name || '').trim(),
    last_name: String(last_name || '').trim(),
    phone_number: String(phone_number || '').trim()
  };

  const response = await axios.post(UPDATE_USER, payload, get_request_config());
  const response_payload = response?.data;

  if (response_payload?.status && String(response_payload.status).toLowerCase() !== 'success') {
    throw new Error(String(response_payload?.message || 'Unable to update profile details.'));
  }

  return normalize_profile({
    ...(response_payload?.data || {}),
    id: response_payload?.data?.user_id || normalized_user_id
  });
}
